import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const ImportIndex = lazy(() => import('./import/Index'))
const PostHoldersIndex = lazy(() => import('./post-holders/Index'))
const TrashIndex = lazy(() => import('./trash/Index'))

export const DocumentationAdminRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--documentation--admin']}>
    <Route index element={<Index />} />
    <Route path='category/:categoryId' element={<Index />} />
    <Route path='import' element={<ImportIndex />} />
    <Route path='post-holders' element={<PostHoldersIndex />} />
    <Route path='trash' element={<TrashIndex />} />
  </SubRouter>
))
